var map = {
	"./": [
		217,
		5
	],
	"./index": [
		217,
		5
	],
	"./index-1c5c47b4": [
		103
	],
	"./index-1c5c47b4.js": [
		103
	],
	"./index.js": [
		217,
		5
	],
	"./ionicpwaelements": [
		591,
		6
	],
	"./ionicpwaelements.js": [
		591,
		6
	],
	"./loader": [
		141
	],
	"./loader.js": [
		141
	],
	"./pwa-action-sheet.entry": [
		218,
		4
	],
	"./pwa-action-sheet.entry.js": [
		218,
		4
	],
	"./pwa-camera-modal-instance.entry": [
		219,
		3
	],
	"./pwa-camera-modal-instance.entry.js": [
		219,
		3
	],
	"./pwa-camera-modal.entry": [
		220,
		2
	],
	"./pwa-camera-modal.entry.js": [
		220,
		2
	],
	"./pwa-camera.entry": [
		221,
		1
	],
	"./pwa-camera.entry.js": [
		221,
		1
	],
	"./pwa-toast.entry": [
		222,
		0
	],
	"./pwa-toast.entry.js": [
		222,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 606;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ionic/pwa-elements/dist/esm-es5 lazy ^\.\/.*$
// module id = 606
// module chunks = 111